import React from "react";
import { useNavigate } from "react-router";
import { useGlobalStore } from "~/store";
import "~/assets/sass/pages/dashboard/dashboard-info.scss";
import DarkDefaultProfileImg from "~/assets/img/defaultImg/dark-profile-large2.png";
import LightDefaultProfileImg from "~/assets/img/defaultImg/light-profile-large.png";
import { QuestionMarkIcon } from "~/assets/svg/InterfaceIcon";
import { useTranslation } from "react-i18next";

const Info = ({ userList, userInfoList }) => {
	const { t } = useTranslation();
	const [
		{
			theme: { theme },
			user: { info },
		},
	] = useGlobalStore();
	const navigate = useNavigate();

	const investProgress = (userInfoList?.investScoreCount / userInfoList?.investJudgeCount) * 100;
	const roundProgress = (userInfoList?.roundEvaluateCount / userInfoList?.roundJudgeCount) * 100;
	const applyProgress = (userInfoList?.applyScoreCount / userInfoList?.applyJudgeCount) * 100;

	return (
		<article className="item info">
			<div className="profile-wrap">
				<div className="img-wrap">
					<img
						src={
							userList?.img
								? userList?.img
								: theme === "dark"
								? DarkDefaultProfileImg
								: LightDefaultProfileImg
						}
						alt={t("pages.DashboardPage.Info.profileImgAlt")}
					/>
				</div>
				<div className="profile">
					<div className="info-wrap">
						<div className="name">{userList?.UserProfile?.name}</div>
						{userList?.role === "admin" ? (
							<div className="role admin">{t("pages.DashboardPage.Info.admin")}</div>
						) : (
							<div className="role user">{t("pages.DashboardPage.Info.member")}</div>
						)}
					</div>
					<div className="company">{userList?.Company?.name}</div>
				</div>
			</div>
			{userList?.role === "admin" ? (
				<div className="auth-wrap admin">
					<ul className="rwd-wrap">
						<li className="auth-item my">
							<span className="auth-label">
								{t("pages.DashboardPage.Info.auth-my")}
							</span>
							<span className="auth-range">all</span>
						</li>
						<li className="auth-item">
							<span className="auth-label">
								{t("pages.DashboardPage.Info.member-invite")}
							</span>
							<button
								type="button"
								className="btn__solid angled"
								color="black"
								onClick={() => navigate("/vc/member")}
							>
								{t("pages.DashboardPage.Info.invite")}
							</button>
						</li>
						<li className="auth-item">
							<span className="auth-label">
								{t("pages.DashboardPage.Info.auth-setting")}
							</span>
							<button
								type="button"
								className="btn__solid angled"
								color="black"
								onClick={() => navigate(`/vc/member/auth`)}
								disabled={!(info.role === 'admin')}
							>
								{t("pages.DashboardPage.Info.modify")}
							</button>
						</li>
					</ul>
				</div>
			) : (
				<div className="auth-wrap">
					<div className="title-wrap">
						<span className="title">{t("pages.DashboardPage.Info.auth-my")}</span>
					</div>
					{userInfoList?.authPlugins.length > 0 ? (
						<ul className="tag-wrap">
							{userInfoList?.authPlugins?.map((plugin, index) => (
								<li className="tag" key={index}>
									{plugin.title}
								</li>
							))}
						</ul>
					) : (
						<div className="no-auth-wrap">
							<p className="no-auth-desc">
								{t("pages.DashboardPage.Info.no-auth-desc")}
							</p>
						</div>
					)}
				</div>
			)}
			<div className="right-wrap">
				<div className="title-wrap info-tooltip">
					<div className="left-title-wrap">
						<h2 className="item-title">{t("pages.DashboardPage.Info.item-title")}</h2>
						<div className="c__tooltip-btn">
							<QuestionMarkIcon />
							<p className="c__tooltip tooltip-info">
								<b>{t("pages.DashboardPage.Info.tooltipMainTitle")}</b>
								{t("pages.DashboardPage.Info.tooltip")}
								<p className="desc">
									<b>{t("pages.DashboardPage.Info.tooltipSubTitle.01")}</b>
									{t("pages.DashboardPage.Info.tooltipDesc.01")}
								</p>
								<p className="desc">
									<b>{t("pages.DashboardPage.Info.tooltipSubTitle.02")}</b>
									{t("pages.DashboardPage.Info.tooltipDesc.02")}
								</p>
								<p className="desc">
									<b>{t("pages.DashboardPage.Info.tooltipSubTitle.03")}</b>
									{t("pages.DashboardPage.Info.tooltipDesc.03")}
								</p>
							</p>
						</div>
					</div>
				</div>
				<ul className="progress-wrap">
					<li className="progress-item invest">
						<span className="progress-label">
							{t("pages.DashboardPage.Info.progress-label.label1")}
						</span>
						<div className="progress-container">
							<div className="progress">
								<div
									className="progress-bar"
									style={{
										width: `${investProgress || 0}%`,
									}}
								/>
							</div>
							<div
								className="progress-count c__tooltip"
								style={{ left: `${investProgress || 0}%` }}
							>
								<span className="complete">
									{`${Number(investProgress.toFixed(0)) || 0}%`}
								</span>
							</div>
						</div>
					</li>
					<li className="progress-item round">
						<span className="progress-label">
							{t("pages.DashboardPage.Info.progress-label.label2")}
						</span>
						<div className="progress-container">
							<div className="progress">
								<div
									className="progress-bar"
									style={{
										width: `${roundProgress || 0}%`,
									}}
								/>
							</div>
							<div
								className="progress-count c__tooltip"
								style={{ left: `${roundProgress || 0}%` }}
							>
								<span className="complete">
									{`${Number(roundProgress.toFixed(0)) || 0}%`}
								</span>
							</div>
						</div>
					</li>
					<li className="progress-item apply">
						<span className="progress-label">
							{t("pages.DashboardPage.Info.progress-label.label3")}
						</span>
						<div className="progress-container">
							<div className="progress">
								<div
									className="progress-bar"
									style={{
										width: `${applyProgress || 0}%`,
									}}
								/>
							</div>
							<div
								className="progress-count c__tooltip"
								style={{ left: `${applyProgress || 0}%` }}
							>
								<span className="complete">
									{`${Number(applyProgress.toFixed(0)) || 0}%`}
								</span>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</article>
	);
};

export default Info;
